<div class="main-container">

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <!-- Header -->
  <app-header></app-header>
  <!-- Page Content Wrapper -->
  <div class="page-content">
    <!-- Form Section -->
    <div class="scrollable-form-wrapper">

      <form class="form-fields-container"
            [formGroup]="form"
            (ngSubmit)="search()">

        <div formArrayName="fields">

          <div *ngFor="let fieldGroup of fields.controls; let i = index"
               [formGroupName]="i"
               class="filter-row">

            <!-- OR Label -->
            <div *ngIf="i !== 0 && fieldGroup.value.logicalOperator === 'OR'"
                 class="logical-operator-label">
              OR
            </div>

            <!-- Field Dropdown -->
            <select class="form-input"
                    formControlName="selectedField">
              <option value="" disabled>Select Field</option>
              <option *ngFor="let option of fieldOptions"
                      [value]="option">
                {{ option }}
              </option>
            </select>

            <!-- Dynamic Value Control -->
            <ng-container [ngSwitch]="fieldGroup.get('selectedField')?.value">

              <!-- Actuality -->
              <select *ngSwitchCase="'Actuality'"
                      class="form-input"
                      formControlName="fieldValue">
                <option value="" disabled>Select Actuality</option>
                <option *ngFor="let option of actualityOptions"
                        [value]="option">
                  {{ option }}
                </option>
              </select>

              <!-- Period -->
              <select *ngSwitchCase="'Period'"
                      class="form-input"
                      formControlName="fieldValue">
                <option value="" disabled>Select Period</option>
                <option *ngFor="let option of periodOptions"
                        [value]="option">
                  {{ option }}
                </option>
              </select>

              <!-- Group -->
              <select *ngSwitchCase="'Group'"
                      class="form-input"
                      formControlName="fieldValue">
                <option value="" disabled>Select Group</option>
                <option *ngFor="let option of groupOptions"
                        [value]="option">
                  {{ option }}
                </option>
              </select>

              <!-- Default Textbox -->
              <input *ngSwitchDefault
                     type="text"
                     class="form-input"
                     formControlName="fieldValue"
                     placeholder="Enter value" />

            </ng-container>

            <!-- AND / OR Buttons -->
            <ng-container *ngIf="fieldGroup.get('selectedField')?.value">
              <button type="button"
                      class="btnAddAndField"
                      (click)="addFieldWithOperator('AND', i)">
                AND
              </button>

              <button type="button"
                      class="btnAddOrField"
                      (click)="addFieldWithOperator('OR', i)">
                OR
              </button>
            </ng-container>

            <!-- Remove Button -->
            <button type="button"
                    class="btnRemoveField"
                    (click)="removeField(i)"
                    *ngIf="fields.length > 1">
              X
            </button>

          </div>
        </div>
      </form>

      <!-- Search Button -->
      <div class="search-button-container">
        <button class="btnSearch"
                type="button"
                (click)="search()">
          Search
        </button>
      </div>

      <div class="display-records">*To display all records without applying filters, click Search</div>
    </div>

    <!-- Grid Section -->
    <div class="grid-container">
      <table mat-table
             [dataSource]="cognos"
             matSort>

        <!-- Select Checkbox -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox color="primary" (change)="toggleAllRows()"
                          [checked]="isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>

          <td mat-cell *matCellDef="let row">
            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                          (change)="selection.toggle(row)"
                          (keydown)="onKeyDown($event, row)"
                          (keyup)="onKeyUp($event, row)"
                          [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <!-- File Name -->
        <ng-container matColumnDef="fileName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            File Name
          </th>
          <td mat-cell *matCellDef="let file">
            {{ file.fileName }}
          </td>
        </ng-container>

        <!-- Year -->
        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Year
          </th>
          <td mat-cell *matCellDef="let file">
            {{ file.year }}
          </td>
        </ng-container>

        <!-- Month -->
        <ng-container matColumnDef="month">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Month
          </th>
          <td mat-cell *matCellDef="let file">
            {{ file.month }}
          </td>
        </ng-container>

        <!-- Period -->
        <ng-container matColumnDef="periodDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Period Description
          </th>
          <td mat-cell *matCellDef="let file">
            {{ file.periodDescription }}
          </td>
        </ng-container>

        <!-- Download -->
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef>
            Download
          </th>

          <td mat-cell *matCellDef="let file">
            <button mat-icon-button
                    color="primary"
                    (click)="download(file); $event.stopPropagation()">
              <mat-icon>download</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="no-data"
              [attr.colspan]="displayedColumns.length"
              *ngIf="hasRecords && !isLoading">
            No records to display
          </td>
        </tr>

        <!-- Header and Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                     showFirstLastButtons>
      </mat-paginator>

    </div>
  </div>
</div>
